import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
// Import background image
import pageHeaderBg from '../../assets/images/backgrounds/page-header-bg-1-1.png';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    pincode: '',
    interest: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,
      once: true,
      mirror: true,
      offset: 100
    });
    
    // Refresh AOS when component mounts
    AOS.refresh();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');
    
    try {
      
      // Create FormData object for traditional form submission
      const formDataObj = new FormData();
      
      // Add all form fields to FormData
      Object.keys(formData).forEach(key => {
        formDataObj.append(key, formData[key]);
      });
      
      // Add Formspree specific fields
      formDataObj.append('_subject', 'New Contact Form Submission - Lexora');
      formDataObj.append('_next', window.location.href);
      formDataObj.append('_captcha', 'false');

      // Send form data to Formspree
      const response = await fetch('https://formspree.io/f/xgvloewa', {
        method: 'POST',
        body: formDataObj,
      });

      // Formspree can return different status codes for success
      // 200, 201, 302 (redirect) are all considered successful
      if (response.ok || response.status === 302) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          pincode: '',
          interest: '',
          message: ''
        });
        
        // Show success message for 5 seconds then clear
        setTimeout(() => {
          setSubmitStatus('');
        }, 5000);
        } else {
          console.error('Formspree returned error status:', response.status);
        const errorText = await response.text();
        console.error('Error response body:', errorText);
        
        // Try fallback method
        await submitFormFallback();
      }
    } catch (error) {
      console.error('Form submission error:', error);
      
      // Try fallback method
      try {
        await submitFormFallback();
      } catch (fallbackError) {
        console.error('Fallback method also failed:', fallbackError);
        setSubmitStatus('error');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // Fallback method using traditional form submission
  const submitFormFallback = () => {
    return new Promise((resolve, reject) => {
      try {
        // Create a temporary form element
        const tempForm = document.createElement('form');
        tempForm.method = 'POST';
        tempForm.action = 'https://formspree.io/f/xgvloewa';
        tempForm.style.display = 'none';
        
        // Add form fields
        Object.keys(formData).forEach(key => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = formData[key];
          tempForm.appendChild(input);
        });
        
        // Add Formspree specific fields
        const subjectInput = document.createElement('input');
        subjectInput.type = 'hidden';
        subjectInput.name = '_subject';
        subjectInput.value = 'New Contact Form Submission - Lexora';
        tempForm.appendChild(subjectInput);
        
        const nextInput = document.createElement('input');
        nextInput.type = 'hidden';
        nextInput.name = '_next';
        nextInput.value = window.location.href;
        tempForm.appendChild(nextInput);
        
        const captchaInput = document.createElement('input');
        captchaInput.type = 'hidden';
        captchaInput.name = '_captcha';
        captchaInput.value = 'false';
        tempForm.appendChild(captchaInput);
        
        // Add form to document and submit
        document.body.appendChild(tempForm);
        
        // Set a timeout to check if submission was successful
        const timeout = setTimeout(() => {
          document.body.removeChild(tempForm);
          reject(new Error('Form submission timeout'));
        }, 10000);
        
        // Submit the form
        tempForm.submit();
        
        // If we reach here, assume success
        setTimeout(() => {
          clearTimeout(timeout);
          document.body.removeChild(tempForm);
          setSubmitStatus('success');
          setFormData({
            name: '',
            email: '',
            phone: '',
            pincode: '',
            interest: '',
            message: ''
          });
          
          setTimeout(() => {
            setSubmitStatus('');
          }, 5000);
          
          resolve();
        }, 2000);
        
      } catch (error) {
        reject(error);
      }
    });
  };

  return (
          <Layout>
        {/* Page Header */}
        <section 
          className="relative py-24 bg-kajaria-blue-200"
          style={{ 
            backgroundImage: `url(${pageHeaderBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
        <div className="container mx-auto px-4 relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-kajaria-blue-50 mb-6 text-center" data-aos="fade-up" data-aos-duration="1000">Contact Us</h2>
          <nav className="flex items-center text-kajaria-blue-50 justify-center" data-aos="fade-up" data-aos-delay="200">
            <Link to="/" className="flex items-center hover:text-blue-200 transition-colors">
              <i className="icon-home mr-2"></i>
              Home
            </Link>
            <span className="mx-3">/</span>
            <span>Contact Us</span>
          </nav>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 relative">
        {/* Background removed - image file does not exist */}
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Information */}
            <div data-aos="fade-right" data-aos-duration="1000">
              <div className="sec-title sec-title--border mb-12" data-aos="fade-up" data-aos-delay="200">
                <h6 className="sec-title__tagline">contact</h6>
                <h3 className="sec-title__title">Reach out & connect with us</h3>
              </div>

              <p className="text-gray-700 mb-8 text-lg" data-aos="fade-up" data-aos-delay="300">
                For enquiry regarding Adhesives, Grouts & Tile Cleaner, Please Contact
              </p>

              {/* Contact Info Cards */}
              <div className="space-y-6">
                {/* Phone */}
                <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-blue-600 hover:shadow-xl transition-shadow" data-aos="fade-up" data-aos-delay="400">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                      <FaPhone className="text-blue-600 text-xl" />
                    </div>
                    <div>
                      <p className="text-gray-600 text-sm mb-1">Call Us</p>
                      <div className="flex flex-col gap-2">
                        <a 
                          href="tel:8758435000" 
                          className="text-xl font-semibold text-gray-900 hover:text-blue-600 transition-colors"
                          title="call now"
                        >
                          8758435000
                        </a>
                        <a 
                          href="tel:8758434000" 
                          className="text-xl font-semibold text-gray-900 hover:text-blue-600 transition-colors"
                          title="call now"
                        >
                          8758434000
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-green-600 hover:shadow-xl transition-shadow" data-aos="fade-up" data-aos-delay="500">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                      <FaEnvelope className="text-green-600 text-xl" />
                    </div>
                    <div>
                      <p className="text-gray-600 text-sm mb-1">Email Us</p>
                      <a 
                        href="mailto:lexorachembond@gmail.com" 
                        className="text-xl font-semibold text-gray-900 hover:text-green-600 transition-colors"
                        title="mail now"
                      >
                        lexorachembond@gmail.com
                      </a>
                    </div>
                  </div>
                </div>

                {/* Address */}
                <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-orange-600 hover:shadow-xl transition-shadow" data-aos="fade-up" data-aos-delay="600">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <FaMapMarkerAlt className="text-orange-600 text-xl" />
                    </div>
                    <div>
                      <p className="text-gray-600 text-sm mb-1">Visit Us</p>
                      <address className="text-lg font-semibold text-gray-900 not-italic leading-relaxed">
                        <a 
                          href="https://www.google.com/maps/place/LEXORA+CHEMBOND+LLP/@22.800706,70.891414,16z/data=!4m6!3m5!1s0x39598d000877c079:0x9da77e2b5a55dd01!8m2!3d22.8007063!4d70.8914137!16s%2Fg%2F11xrv6wf10?hl=en&entry=ttu&g_ep=EgoyMDI1MDgwNC4wIKXMDSoASAFQAw%3D%3D" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="hover:text-orange-600 transition-colors"
                          title="Visit this Location"
                        >
                          Industrial Estate 9, nr. solo sanitaryware, <br />
                          Lalpar, Morbi, Gujarat 363642
                        </a>
                      </address>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div data-aos="fade-left" data-aos-duration="1000">
              <div className="bg-white rounded-lg shadow-xl p-8 relative overflow-hidden" data-aos="fade-up" data-aos-delay="300">
                {/* Background removed - image file does not exist */}
                
                <div className="relative z-10">
                  <div className="mb-8" data-aos="fade-up" data-aos-delay="400">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
                      Get in touch with us and enjoy<br />
                      Top-notch support
                    </h2>
                  </div>

                  {/* Status Messages */}
                  {submitStatus === 'success' && (
                    <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                      <div className="flex items-center">
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <div>
                          <strong>Success!</strong> Your message has been sent successfully. We'll get back to you soon.
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {submitStatus === 'error' && (
                    <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                      <div className="flex items-center">
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                        <div>
                          <strong>Error!</strong> There was an issue sending your message. Please check your internet connection and try again. If the problem persists, please contact us directly.
                        </div>
                      </div>
                    </div>
                  )}

                  <form 
                    onSubmit={handleSubmit} 
                    className="space-y-6" 
                    data-aos="fade-up" 
                    data-aos-delay="500"
                  >
                    {/* Name */}
                    <div>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Your name"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Email ID"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="Phone Number"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      />
                    </div>

                    {/* Pincode */}
                    <div>
                      <input
                        type="text"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleInputChange}
                        placeholder="Enter Your Pincode"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      />
                    </div>

                    {/* Interest */}
                    <div>
                      <select
                        name="interest"
                        value={formData.interest}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white"
                      >
                        <option value="">Select Your Interest</option>
                        <option value="To buying products">To buying products</option>
                        <option value="To take dealership">To take dealership</option>
                      </select>
                    </div>

                    {/* Message */}
                    <div>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder="Write message"
                        rows="4"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-vertical"
                      ></textarea>
                    </div>

                    {/* Submit Button */}
                    <div>
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="floens-btn w-full text-white font-bold py-4 px-6 rounded-lg transition-colors flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <span>{isSubmitting ? 'Sending...' : 'Send Message'}</span>
                        {!isSubmitting && <i className="icon-right-arrow ml-2"></i>}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map */}
      <section className="py-0" data-aos="fade-up" data-aos-duration="1000">
        <div className="container-fluid px-0">
          <div className="w-full h-96">
            <iframe
              title="Lexora Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.047431951008!2d70.88883877513365!3d22.800706279329923!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39598d000877c079%3A0x9da77e2b5a55dd01!2sLEXORA%20CHEMBOND%20LLP!5e0!3m2!1sen!2sin!4v1754502849076!5m2!1sen!2sin"
              className="w-full h-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;